import Vue from 'vue'

//微信配置
Vue.prototype.share_base = function (appid, timestamp, noncestr, signature, is_debug) {
	if (is_debug !== "true") {
		wx.config({
			debug: false,
			appId: appid,
			timestamp: timestamp,
			nonceStr: noncestr,
			signature: signature,
			jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', ],
		})
	}
	if (is_debug === "true") {
		wx.config({
			debug: true,
			appId: appid,
			timestamp: timestamp,
			nonceStr: noncestr,
			signature: signature,
			jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', ],
		})

	}
}
//微信分享给朋友
Vue.prototype.share = function (title, desc, url, callback) {
	wx.ready(function() {
		wx.onMenuShareAppMessage({
			title: title,
			desc: desc,
			link: url,
			type: '',
			dataUrl: '',
			success: function () {
				callback()
			},
			cancel: function () {
			},
		})
	})
}



// WEBPACK FOOTER //
// ./src/global_share.js